import gql from 'graphql-tag';

export default gql`
fragment OrderAllData on Order {
    id
    total_amount
    total_sum
    shipping_cost
    timetable_time_slot {
        id
        sector {
            name
        }
        range_date
        timeRange {
            time_from
            time_to
        }
    }
    post_point {
        id
        name
        ext_id
        postcode
        city
        street_name
        street_type
        house_number
        latitude
        longitude
        service_point_type
        working_hours
    }
    shipping_method {
        id
        name
    }
    payment_method {
        id
        name
    }
    shipping_name
    shipping_postcode
    shipping_city
    shipping_street
    shipping_house_number
    shipping_telephone
    shipping_note
    billing_name
    billing_postcode
    billing_city
    billing_street
    billing_house_number
    vat_number
    is_company
    user {
        id
        name
    }
    comment
    lyoness_card_number
    order_products {
        price
        special_price
        default_quantity_name
        default_quantity_piece
        alternative_quantity_name
        alternative_quantity_piece
        product {
            id
            name
            weight
        }
        sliced
        additional_information
    }
    status {
        title
        code
    }
    coupon_data {
        name
        code
        product_discount
        shipping_discount
    }
    linked_orders {
        id
    }
    parent_order {
        id
    }
    created_at
    contact_data {
        contact_name
        contact_email
        contact_telephone

    }
    erp_comment
    admin_id
    donation_data {
        type
        amount
    }
    payment_method_cost
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/OrderAllData.ts